import { Trans } from '@lingui/macro';
import { Button, useMediaQuery, useTheme } from '@mui/material';
import dynamic from 'next/dynamic';
import { useWalletModalContext } from 'src/hooks/useWalletModal';

const WalletModal = dynamic(() => import('./WalletModal').then((module) => module.WalletModal));

export interface ConnectWalletProps {
  funnel?: string;
}

export const ConnectWalletButton: React.FC<ConnectWalletProps> = () => {
  const { setWalletModalOpen } = useWalletModalContext();
  const { breakpoints } = useTheme();
  const md = useMediaQuery(breakpoints.up('md'));

  return (
    <>
      <Button
        variant="contained"
        color="success"
        size={md ? 'large' : 'medium'}
        onClick={() => {
          window.gtag('event', 'connect_wallet', {
            location: window.location.href,
          });
          setWalletModalOpen(true);
        }}
      >
        <Trans>Connect wallet</Trans>
      </Button>
      <WalletModal />
    </>
  );
};
